import {
  SET_MFA_DIALOG,
  SET_CONSENT_ACCEPTED_OPTIONS,
  SET_TENANT_SETTINGS,
  INITIALIZE_SDK,
  SET_CURRENT_USER,
  SET_AUTHENTICATED,
  SET_LOADING,
  SET_SDK_ERROR,
  TOGGLE_BACKDROP,
  SET_TENANT_ID,
  SET_CONFIG,
  SET_ERROR,
  SET_CONSENT_DECISIONS,
  SET_VERIFF_SESSION_DATA,
  SET_CURRENT_USER_MARKET,
} from "./actionTypes"

export const initialState = {
  mfaDialog: false,
  consentAcceptedOptions: [],
  tenantSettings: {},
  sdkInitialized: false,
  customer: null,
  isAuthenticated: false,
  loading: false,
  sdkError: false,
  showBackdrop: false,
  tenantId: null,
  error: {
    hasError: false,
    errorMessage: "",
  },
  consentDecisions: [],
  veriffSessionData: null,
  currentUserMarket: null,
}

const updateReducer = (state, updatedState) => ({
  ...state,
  ...updatedState,
})

export const globalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MFA_DIALOG:
      return updateReducer(state, { mfaDialog: action.payload })
    case SET_CONSENT_ACCEPTED_OPTIONS:
      return updateReducer(state, { consentAcceptedOptions: action.payload })
    case SET_TENANT_SETTINGS:
      return updateReducer(state, { tenantSettings: action.payload })
    case INITIALIZE_SDK:
      return updateReducer(state, { sdkInitialized: action.payload })
    case SET_CURRENT_USER:
      return updateReducer(state, { customer: action.payload })
    case SET_AUTHENTICATED:
      return updateReducer(state, { isAuthenticated: action.payload })
    case SET_LOADING:
      return updateReducer(state, { loading: action.payload })
    case SET_SDK_ERROR:
      return updateReducer(state, { sdkError: action.payload })
    case TOGGLE_BACKDROP:
      return updateReducer(state, { showBackdrop: action.payload })
    case SET_TENANT_ID:
      return updateReducer(state, { tenantId: action.payload })
    case SET_CONFIG:
      return updateReducer(state, { config: action.payload })
    case SET_ERROR:
      return updateReducer(state, { error: action.payload })
    case SET_CONSENT_DECISIONS:
      return updateReducer(state, { consentDecisions: action.payload })
    case SET_VERIFF_SESSION_DATA:
      return updateReducer(state, { veriffSessionData: action.payload })
    case SET_CURRENT_USER_MARKET:
      return updateReducer(state, { currentUserMarket: action.payload })
    default:
      return state
  }
}
